import { Box, Container, Link, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 3,
        px: 2,
        backgroundColor: (theme) => theme.palette.primary.main,
      }}
    >
      <Container sx={{ flexGrow: 1, textAlign: "center" }}>
        <Typography
          variant="body2"
          sx={{ color: (theme) => theme.palette.primary.contrastText }}
        >
          {`© Copyright ${new Date().getFullYear()} - Version 1.8.0 - `}
          <Link color="inherit" href="https://steuertools.de" target="_blank">
            steuertools.de
          </Link>
          {` - `}
          <Link
            color="inherit"
            href="https://steuertools.de/impressum/"
            target="_blank"
          >
            Impressum
          </Link>
          {` - `}
          <Link
            color="inherit"
            href="https://steuertools.de/agb-steuertools-app/"
            target="_blank"
          >
            AGB
          </Link>
          {` - `}
          <Link
            color="inherit"
            href="https://steuertools.de/datenschutzerklaerung/"
            target="_blank"
          >
            Datenschutz
          </Link>
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
